import type { LocaleMessageBundle } from '../../types'

export const errorMessages: LocaleMessageBundle = {
  vi: {
    'errors.forbidden.code': '403',
    'errors.forbidden.title': 'Không có quyền truy cập',
    'errors.forbidden.message': 'Tài khoản của bạn chưa được cấp quyền để mở trang này.',
    'errors.forbidden.backHome': 'Về trang chính',
    'errors.network': 'Không thể kết nối máy chủ. Vui lòng kiểm tra mạng và thử lại.',
    'errors.timeout': 'Kết nối quá thời gian chờ. Vui lòng thử lại.',
    'errors.unexpected': 'Đã có lỗi xảy ra. Vui lòng thử lại.',
    'errors.notification.error': 'Thao tác không thành công.',
    'errors.notification.warning': 'Thao tác cần chú ý.',
    'errors.http.400': 'Yêu cầu không hợp lệ.',
    'errors.http.401': 'Vui lòng đăng nhập lại để tiếp tục.',
    'errors.http.403': 'Bạn không có quyền thực hiện thao tác này.',
    'errors.permissionDenied': 'Không có quyền truy cập',
    'errors.http.404': 'Không tìm thấy dữ liệu yêu cầu.',
    'errors.http.408': 'Kết nối quá thời gian chờ. Vui lòng thử lại.',
    'errors.http.409': 'Dữ liệu đang xung đột. Vui lòng tải lại và thử lại.',
    'errors.http.422': 'Dữ liệu nhập chưa hợp lệ.',
    'errors.http.429': 'Thao tác quá nhiều lần. Vui lòng thử lại sau.',
    'errors.http.500': 'Máy chủ đang gặp lỗi. Vui lòng thử lại sau.',
    'errors.http.502': 'Cổng kết nối máy chủ đang lỗi. Vui lòng thử lại sau.',
    'errors.http.503': 'Dịch vụ tạm thời không khả dụng. Vui lòng thử lại sau.',
    'errors.http.504': 'Máy chủ phản hồi quá thời gian chờ. Vui lòng thử lại sau.',
    'errors.loyalty.pointsBelowMinimum':
      'Số điểm sử dụng chưa đạt mức tối thiểu theo chính sách điểm thưởng.',
    'errors.loyalty.pointsNotMultiple': 'Số điểm sử dụng không đúng bước điểm quy định.',
    'errors.loyalty.insufficientBalance': 'Khách hàng không đủ điểm để thực hiện thanh toán.',
    'errors.loyalty.redemptionLimitExceeded':
      'Số điểm sử dụng vượt quá giới hạn cho phép của hóa đơn.',
    'errors.loyalty.partialPaymentNotAllowed':
      'Chính sách điểm không cho phép thanh toán một phần hóa đơn.',
    'errors.loyalty.customerNotEligible': 'Khách hàng không đủ điều kiện sử dụng điểm thưởng.',
  },
  en: {
    'errors.forbidden.code': '403',
    'errors.forbidden.title': 'Access denied',
    'errors.forbidden.message': 'Your account does not have permission to open this page.',
    'errors.forbidden.backHome': 'Back to home',
    'errors.network': 'Cannot connect to the server. Please check your connection and try again.',
    'errors.timeout': 'The request timed out. Please try again.',
    'errors.unexpected': 'Something went wrong. Please try again.',
    'errors.notification.error': 'Action failed.',
    'errors.notification.warning': 'Action needs attention.',
    'errors.http.400': 'The request is invalid.',
    'errors.http.401': 'Please sign in again to continue.',
    'errors.http.403': 'You do not have permission to perform this action.',
    'errors.permissionDenied': 'Permission denied',
    'errors.http.404': 'The requested resource was not found.',
    'errors.http.408': 'The request timed out. Please try again.',
    'errors.http.409': 'The data has changed. Please reload and try again.',
    'errors.http.422': 'The submitted data is invalid.',
    'errors.http.429': 'Too many requests. Please try again later.',
    'errors.http.500': 'The server encountered an error. Please try again later.',
    'errors.http.502': 'The server gateway failed. Please try again later.',
    'errors.http.503': 'The service is temporarily unavailable. Please try again later.',
    'errors.http.504': 'The server took too long to respond. Please try again later.',
    'errors.loyalty.pointsBelowMinimum':
      'Points used are below the minimum required by the loyalty policy.',
    'errors.loyalty.pointsNotMultiple':
      'Points used do not match the required redemption increment.',
    'errors.loyalty.insufficientBalance':
      'The customer does not have enough points for this payment.',
    'errors.loyalty.redemptionLimitExceeded': 'Points used exceed the invoice redemption limit.',
    'errors.loyalty.partialPaymentNotAllowed':
      'The loyalty policy does not allow partial invoice payment.',
    'errors.loyalty.customerNotEligible': 'The customer is not eligible to redeem loyalty points.',
  },
}
